export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#2B2B2B" />
    <path
      d="M32 20c5.6 7 8.5 11.6 8.5 15.8a8.5 8.5 0 1 1-17 0C23.5 31.6 26.4 27 32 20z"
      fill="#F5F2EC"
    />
    <circle cx="20" cy="14.5" r="2.4" fill="#7C9885" />
    <circle cx="32" cy="10.5" r="2.4" fill="#7C9885" />
    <circle cx="44" cy="14.5" r="2.4" fill="#7C9885" />
  </svg>
);

export default function Logo({ light = false }) {
  return (
    <span className="flex items-center gap-2.5" data-testid="brand-logo">
      <LogoMark className="h-9 w-9" />
      <span className="flex flex-col leading-none">
        <span
          className={`font-serif text-xl font-semibold tracking-tight ${
            light ? "text-oat-100" : "text-charcoal-900"
          }`}
        >
          OmniMist<span className="text-sage-500">™</span>
        </span>
        <span
          className={`mt-1 text-[9px] font-medium uppercase tracking-[0.32em] ${
            light ? "text-oat-100/60" : "text-charcoal-500"
          }`}
        >
          Kitchen Craft
        </span>
      </span>
    </span>
  );
}
